import React from 'react';
import { useSelector } from 'react-redux';

import Table from 'components/Table';

import {
  getAltHypotesisSign,
  getH0,
  getH1,
  getTableData
} from 'store/scenes/inferentialStatistics/selectors';

const THypothesis = () => {
  const altHypothesisSign = useSelector(state => getAltHypotesisSign(state));
  const h0 = useSelector(state => getH0(state));
  const h1 = useSelector(state => getH1(state));
  const tableData = useSelector(state => getTableData(state));
  const tableHeaders = ['n', 'Mean', 'Standard Deviation', 'Standard Error', 'df', 'T-Statistic', 'P-Value'];

  return (
    <div className="content-item">
      <h3>One Sample <i>t</i> Hypothesis Test Summary</h3>
      <span className="font-900 font-16 mb-10">μ: mean of population</span>
      <table className="infStatMarkup-table">
        <tbody>
          <tr>
            <td>
              Null Hypothesis
            </td>
            <td>
              <span className="font-900 font-16 mb-10 mr-5">H<sub>0</sub>: μ =</span><span>{h0}</span>
            </td>
          </tr>
          <tr>
            <td>
              Alternative Hypothesis
            </td>
            <td>
              <span className="font-900 font-16 mb-10 mr-5">H<sub>1</sub>: μ {altHypothesisSign}</span><span>{h1}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <Table
        tableHeaders={tableHeaders}
        tableData={tableData}
      />
    </div>);
};

export default THypothesis;
